import React from 'react';
import PropTypes from 'prop-types';
import ContextMenuItem
  from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenuItem/ContextMenuItem';
import ContextMenu from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenu';
import RaaThresholdRange from '../../../../classes/RaaThresholdRange';

const CrudItemContextMenu = ({
  rowData = {},
  onEditClick,
  onDeleteClick,
  onCloneClick,
  onViewClick,
  hasEditPrivileges = true,
  isNotificationGroup = false,
  onTestActionClick = () => {},
}) => {
  if (!hasEditPrivileges) {
    return null;
  }

  return (
    <ContextMenu disabled={rowData.disabled}>
      <ContextMenuItem
        itemIcon="pencil"
        itemText="Edit"
        onClickHandler={() => onEditClick(rowData)}
      />
      <ContextMenuItem
        itemIcon="copy"
        itemText="Clone"
        onClickHandler={() => onCloneClick(rowData)}
      />
      <ContextMenuItem
        itemIcon="trash-can"
        itemText="Delete"
        onClickHandler={() => onDeleteClick(rowData)}
      />
      <ContextMenuItem
        itemIcon="info-circle"
        itemText="View"
        onClickHandler={() => onViewClick(rowData)}
      />
      {
            isNotificationGroup && (
            <ContextMenuItem
              itemIcon="check-circle"
              itemText="Test"
              onClickHandler={() => onTestActionClick()}
            />
            )
        }
    </ContextMenu>
  );
};
CrudItemContextMenu.defaultProps = {
  isNotificationGroup: false,
  onTestActionClick: () => {},
};
CrudItemContextMenu.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  rowData: PropTypes.shape(RaaThresholdRange).isRequired,
  hasEditPrivileges: PropTypes.bool.isRequired,
  onCloneClick: PropTypes.func.isRequired,
  onViewClick: PropTypes.func.isRequired,
  isNotificationGroup: PropTypes.bool,
  onTestActionClick: PropTypes.func,
};

export default CrudItemContextMenu;
